export enum KEY_INFO {
  SOMEONE_AT_HOME = "someoneAtHome",
  CONCIERGE = "concierge",
  HIDE_KEY = "hideKey",
  LOCATION_COMMENT = "keyInfoLocationComment",
  DROPDOWN = "keyInfoDropdown",
}
